import styled, { keyframes } from 'styled-components';

export const LiveStatusContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  background-color: #e6f7ff;
  border: 1px solid #91d5ff;
  padding: 4px 12px;
  border-radius: 16px;
`;

const pulse = keyframes`
  0% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(255, 82, 82, 0.7);
  }
  70% {
    transform: scale(1);
    box-shadow: 0 0 0 10px rgba(255, 82, 82, 0);
  }
  100% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(255, 82, 82, 0);
  }
`;

export const LiveIndicator = styled.div`
  width: 10px;
  height: 10px;
  background-color: #ff4d4f;
  border-radius: 50%;
  box-shadow: 0 0 0 0 rgba(0, 0, 0, 1);
  transform: scale(1);
  animation: ${pulse} 2s infinite;
`;

export const LiveText = styled.span`
  font-weight: 600;
  color: #0050b3;
  font-size: 14px;
`;
